import { createSelector } from 'reselect'

const getJobCodes = ({ jobCode }) => jobCode.records

const jobCodeSelectors = {
  getJobCodeOptions: createSelector([getJobCodes], (jobCodes) => {
    if (!jobCodes.length) {
      return []
    }

    return jobCodes.map((code) => {
      return { label: code.value.name, value: code.value }
    })
  }),
}

export default jobCodeSelectors
